import React, { Component } from "react";
import { toast } from "react-toastify";
import AdminUserPhotosetsModal from "./adminUserPhotosetsModal";
import {
  Pagination as MuiPagination,
  Grid,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Modal,
  Button,
  Box,
  Typography,
} from "@mui/material";
import { Img } from "react-image";
import LoadingScreen from "../parts/loadingScreen";
import Moment from "moment";
import { API_URL, UPLOADS_BUCKET } from "../../config";
import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";

Moment.locale("en");

class AdminUsers extends Component {
  _isMounted = false;

  state = {
    loading: true,
    activePage: 1,
    pages: [],
    count: 0,
    photosets: [],
    tiers: [],
    selectedPages: [],
    photolist: [],
    showModal: false,
    selectedPhotoset: 0,
    modalLoading: true,
    photosLoading: true,
    modalPhotos: [],
    photosetDetails: [],
    photoCount: 0,
    users: [],
    modalMode: "list",
    subModalMode: "thumbs",
    currentFullImage: "",
    prevIndex: null,
    nextIndex: null,
    versionTime: 1591213166,
  };

  constructor(props) {
    super(props);
    if (localStorage.getItem("adminUsers")) {
      const data = JSON.parse(localStorage.getItem("adminUsers"));
      console.log(
        "localstorage length",
        localStorage.getItem("adminUsersLength")
      );

      console.log("data", data);

      if (data.length) {
        this.setState({
          count: localStorage.getItem("adminUsersLength"),
          users: data,
          loading: false,
        });
      }
    }
  }

  componentDidMount() {
    this._isMounted = true;

    this.getAdminList();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  pagination = (i = this.state.activePage) => {
    const x = 50;

    let divisions = Math.ceil(this.state.count / x);
    if (divisions < 1) divisions = 1;

    let pages = [];

    if (i < 1) i = 1;
    if (i > divisions) i = divisions;
    this.setState({ activePage: i });

    for (let number = 1; number <= divisions; number++) {
      pages.push(
        <Pagination.Item
          key={number}
          active={number === i}
          onClick={() => {
            this.setState({ activePage: number });
            this.pagination(number);
          }}
        >
          {number}
        </Pagination.Item>
      );
    }

    // select the pages to show
    const floor = (i - 1) * x;
    const ceil = (i - 1) * x + x;

    console.log("floor", floor);
    console.log("ceil", ceil);

    const users = this.state.users;
    const selectedPages = users.slice(floor, ceil);

    console.log(selectedPages);

    // let sp = [];

    // selectedPages.forEach((item) => {
    //   let sp_list = {
    //     photosetName: item.photosetName,
    //     createdAt: item.createdAt,
    //     id: item.id,
    //     photosetStatus: item.photosetStatus,
    //     userId: item.userId,
    //     photos: this.state.photolist[item.id],
    //   };

    //   sp.push(sp_list);
    // });

    // console.log(sp);

    if (this._isMounted)
      this.setState({
        pages: pages,
        selectedPages: users,
        loading: false,
      });
  };

  getAdminList = async () => {
    try {
      const token = this.props.token;

      const response = await fetch(
        API_URL + "/admin/v1/users",
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          method: "GET",
        }
      );

      if (response.ok) {
        const responseJson = await response.json();

        console.log(responseJson);

        this.setState({
          count: responseJson.length,
          users: responseJson,
          loading: false,
        });

        this.pagination();
      } else {
        toast.error(`Failed to fetch users: ${response.status}`);
        this.setState({ loading: false });
      }
    } catch (err) {
      console.error("Error getting users from endpoint:", err);
      toast.error("Error getting users from endpoint: " + err.message);
      this.setState({ loading: false });
    }
  };

  getPhotosetList = async (id) => {
    //admin/v1/photosets/list
    try {
      const token = this.props.token;

      const body = JSON.stringify({
        userId: id,
      });

      const response = await fetch(
        API_URL + "/admin/v1/users/photosets/list",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: body,
          method: "POST",
        }
      );

      const responseData = await response;
      if (responseData.status === 200) {
        const responseJson = await responseData.json();

        console.log(responseJson);

        const photolist = responseJson.photolist;
        let photos = [];

        photolist.forEach((item) => {
          const photosetId = item.photosetId;
          photos[photosetId] = item.photos;
        });

        this.setState({
          photosetCount: responseJson.photosetlist.length,
          photosets: responseJson,
          photolist: photos,
          modalLoading: false,
        });
      } else {
        toast.warn("Something went wrong: Error " + responseData.status);
        this.setState({ photosetLoading: false });
      }
    } catch (err) {
      toast.error("Error getting photoset list from endpoint: " + err);
    }
  };

  openModal = (i, id, index, photoStatus, prev, next) => {
    console.log("prev", prev);
    console.log("current index id", index);
    console.log("next", next);

    this.setState({ modalMode: "single" });

    // i filename
    // id is key
    // index
    // photostatus
    // prev index
    // next index

    if (prev > 0) {
      this.setState({
        prevItem: this.state.modalPhotos[prev],
        prevIndex: prev,
      });
    } else {
      this.setState({ PrevItem: null, prevIndex: null });
    }

    if (next < this.state.modalPhotos.length) {
      this.setState({
        nextItem: this.state.modalPhotos[next],
        nextIndex: next,
      });
    } else {
      this.setState({ nextItem: null, prevIndex: null });
    }

    if (photoStatus === "SUCCESS") {
      if (this._isMounted) {
        this.setState({ currentIndexId: index });

        let origKey;

        if (this.state.photosetDetails.createdAt < this.state.versionTime) {
          origKey =
            "photosets/" +
            this.state.photosetDetails.userId +
            "/" +
            this.state.selectedPhotoset +
            "/" +
            i;
        } else {
          let filename = i.replace(/\.[^/.]+$/, "") + ".jpg";

          origKey =
            "photosets/" +
            this.state.photosetDetails.userId +
            "/" +
            this.state.selectedPhotoset +
            "/optimized/" +
            filename;
        }

        console.log(id);

        this.getImage(origKey, id, i);
      }
    } else {
      toast.warn("This photo is still processing. Please check back later");
    }
  };

  showModal = (id) => {
    if (this._isMounted)
      this.setState({
        showModal: true,
        //selectedPhotoset: id,
        //modalPhotos: [],
        //photosetDetails: [],
        selectedUserid: id,
        modalLoading: true,
      });

    this.getPhotosetList(id);
  };

  getPhotosetDetails = async (id) => {
    try {
      const token = this.props.token;

      this.setState({ modalLoading: true });

      const body = JSON.stringify({
        setId: id,
      });

      const response = await fetch(
        API_URL + "/admin/v1/photosets/details",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: body,
          method: "POST",
        }
      );

      const responseData = await response;
      if (responseData.status === 200) {
        const responseJson = await responseData.json();

        console.log(responseJson);
        this.setState({ photosetDetails: responseJson[0], modalMode: "set" });
        this.getPhotos(this.state.selectedUserid, id);
      } else {
        toast.warn("Something went wrong: Error " + responseData.status);
      }
      this.setState({ modalLoading: false });
    } catch (err) {
      toast.error("Error getting photoset list from endpoint: " + err);
      this.setState({ modalLoading: false });
    }
  };

  getPhotos = async (userId, photosetId) => {
    try {
      const token = this.props.token;

      this.setState({ photosLoading: true, modalPhotos: [] });

      const body = JSON.stringify({
        setId: photosetId,
      });

      const response = await fetch(
        API_URL + "/admin/v1/photosets/list/photos",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: body,
          method: "POST",
        }
      );

      const responseData = await response;
      if (responseData.status === 200) {
        const responseJson = await responseData.json();
        console.log(responseJson);

        const s3 = new S3Client({
          region: "us-east-1",
          credentials: this.props.AWS?.config?.credentials,
        });

        this.setState({ photoCount: responseJson.length });

        responseJson.forEach(async (item, index) => {
          let filename = item.fileName.replace(/\.[^/.]+$/, "") + ".jpg";
          let key = "photosets/" + userId + "/" + photosetId + "/thumbs/" + filename;

          const command = new GetObjectCommand({
            Bucket: UPLOADS_BUCKET,
            Key: key,
          });

          try {
            const url = await getSignedUrl(s3, command, { expiresIn: 100 });
            let newImage = {
              src: url,
              key: item.id,
              width: 0.5,
              height: 0.5,
              status: item.photoStatus,
              f: item.fileName,
              alt: "thumbs",
            };

            const newImages = this.state.modalPhotos.concat(newImage);

            if (this._isMounted) {
              this.setState({
                modalPhotos: newImages,
              });
            }
          } catch (err) {
            toast.warn("Failed to get thumbs");
          }
        });
      } else {
        toast.warn("Something went wrong: Error " + responseData.status);
      }
      this.setState({ modalLoading: false });
    } catch (err) {
      toast.error("Error getting photoset list from endpoint: " + err);
      this.setState({ modalLoading: false });
    }
  };

  back = () => {
    this.setState({ modalMode: "list" });
  };

  render() {
    if (this.state.loading) return <LoadingScreen />;

    if (!this.state.loading && this.state.selectedPages.length === 0)
      return (
        <div className="mt-5">
          <h1>No users</h1>
        </div>
      );

    return (
      <Box sx={{ p: 5, textAlign: "left" }}>
        <Typography variant="h4" gutterBottom>
          Users
        </Typography>

        <Modal
          open={this.state.showModal}
          onClose={() => {
            this.setState({ showModal: false, modalMode: "list" });
          }}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Paper sx={{ width: "80%", maxHeight: "90vh", overflow: "auto", p: 4 }}>
            {this.state.modalLoading ? (
              <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}>
                <CircularProgress />
              </Box>
            ) : (
              <React.Fragment>
                {this.state.modalMode === "list" ? (
                  <AdminUserPhotosetsModal
                    data={this.state.photosets}
                    photos={this.state.photolist}
                    count={this.state.photosetCount}
                    setMode={this.getPhotosetDetails}
                  />
                ) : (
                  <React.Fragment>
                    <Box sx={{ mb: 2 }}>
                      <Button variant="contained" onClick={this.back}>
                        Back
                      </Button>
                    </Box>
                    <Box>
                      <Typography variant="h5">
                        {this.state.photosetDetails.photosetName}
                      </Typography>
                      <Chip
                        label={this.state.photosetDetails.TierName}
                        sx={{
                          backgroundColor:
                            this.state.photosetDetails.TierColor,
                          color: "white",
                        }}
                      />
                    </Box>
                    <Typography>
                      Uploaded by {this.state.photosetDetails.userId}
                    </Typography>
                    <Typography variant="body2">
                      {this.state.photoCount} Photos
                    </Typography>

                    <Grid container spacing={2}>
                      {this.state.photosLoading && (
                        <Grid item xs={12} sx={{ textAlign: "center" }}>
                          <CircularProgress />
                        </Grid>
                      )}

                      {this.state.photoCount === 0 &&
                      !this.state.photosLoading ? (
                        <Grid item xs={12} sx={{ textAlign: "center" }}>
                          <Typography variant="h6">No photos</Typography>
                        </Grid>
                      ) : (
                        <React.Fragment>
                          {this.state.modalPhotos.map((image, index) => (
                            <Grid
                              item
                              lg={2}
                              md={3}
                              sm={4}
                              xs={6}
                              key={image.id + "-" + index}
                              sx={{ position: "relative" }}
                            >
                              <Img
                                src={image.src}
                                loader={
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      height: "100px",
                                    }}
                                  >
                                    <CircularProgress />
                                  </Box>
                                }
                                onClick={() =>
                                  this.openModal(
                                    image.f,
                                    image.key,
                                    index,
                                    image.status,
                                    index - 1,
                                    index + 1
                                  )
                                }
                                style={{
                                  width: "100%",
                                  cursor: "pointer",
                                  border: "1px solid #ddd",
                                  borderRadius: "4px",
                                }}
                              />
                              <Box
                                sx={{
                                  position: "absolute",
                                  bottom: 0,
                                  left: 0,
                                  right: 0,
                                  backgroundColor: "rgba(0,0,0,0.5)",
                                  color: "white",
                                  p: "2px 4px",
                                  textAlign: "center",
                                }}
                              >
                                <Typography variant="caption">
                                  <b>{image.f}</b>
                                </Typography>
                              </Box>
                            </Grid>
                          ))}
                        </React.Fragment>
                      )}
                    </Grid>
                  </React.Fragment>
                )}
              </React.Fragment>
            )}
          </Paper>
        </Modal>

        <MuiPagination
          count={Math.ceil(this.state.count / 50)}
          page={this.state.activePage}
          onChange={(e, page) => this.pagination(page)}
          showFirstButton
          showLastButton
        />

        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow sx={{ fontWeight: "bold" }}>
                <TableCell>Userid</TableCell>
                <TableCell>First Name</TableCell>
                <TableCell>Last Name</TableCell>
                <TableCell>Username</TableCell>
                <TableCell>Registered</TableCell>
                <TableCell>User Type</TableCell>
                <TableCell>Subscription</TableCell>
                <TableCell>Sub End</TableCell>
                <TableCell>Usage</TableCell>
                <TableCell>Emails Sent</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.users.map((item, index) => (
                <TableRow
                  key={index}
                  hover
                  sx={{
                    cursor: "pointer",
                    "&:hover": { backgroundColor: "#f5f5f5" },
                  }}
                  onClick={() => this.showModal(item.userId)}
                >
                  <TableCell>{item.userId}</TableCell>
                  <TableCell>
                    {item.staging.user_metadata.firstName}
                  </TableCell>
                  <TableCell>
                    {item.staging.user_metadata.lastName}
                  </TableCell>
                  <TableCell>
                    {item.staging.user_metadata.username}
                  </TableCell>
                  <TableCell>
                    {item.staging.app_metadata.registered
                      ? "yes"
                      : "no"}
                  </TableCell>
                  <TableCell>
                    {item.staging.app_metadata.accountType ===
                    "NTQzMzQyMzA2MTU3MzEzMTYzNzczZDNk"
                      ? "Admin"
                      : item.staging.app_metadata.accountType}
                  </TableCell>
                  <TableCell>
                    {item.staging.app_metadata.subscription}
                  </TableCell>
                  <TableCell>
                    {Moment.unix(
                      item.staging.app_metadata.subEndDate
                    ).format("LLL")}
                  </TableCell>
                  <TableCell>
                    {(
                      item.staging.app_metadata.current.storage /
                      1073741824
                    ).toFixed(2)}{" "}
                    GB of{" "}
                    {(
                      item.staging.app_metadata.limits.storage /
                      1073741824
                    ).toFixed(2)}{" "}
                    GB
                  </TableCell>
                  <TableCell>
                    {item.staging.app_metadata.current.emails}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  }
}

export default AdminUsers;
